<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M18.3532 0C21.0133 0 22.2484 0.389058 23.2043 1.50196L21.3135 3.16923C20.7214 2.51319 20.0342 2.15905 18.6731 2.2484C16.4428 2.3948 15.4123 3.52802 15.4123 5.95649V5.97231C15.4123 8.44825 16.9663 9.67622 18.8229 9.67622C20.3675 9.67622 21.0991 9.07086 21.0991 9.07086V7.21955H19.0988V4.86222H23.5V10.84C23.5 10.84 21.6833 12 18.4078 12C15.0612 12 12.7147 9.71391 12.7147 5.99604V5.98022C12.7147 2.31773 15.0768 0 18.3532 0ZM3.89484 0.292683L8.69523 8.24324V0.292683H11.1399V11.7073H7.93504L2.87928 3.49688V11.7073H0.5V0.292683H3.89484ZM17.9338 3.99072L17.6009 3.49453H17.4V4.49453H17.6443V3.99072H17.6565L17.9912 4.49453H18.1903V3.49453H17.946V3.99072H17.9338ZM19.014 3.49463V3.72748H18.6512V3.88964H18.9914V4.10031H18.6512V4.26178H19.014V4.49463H18.3923V3.49463H19.014ZM19.5944 3.81331L19.4558 3.49453H19.1541L19.4142 3.99349L19.1547 4.49453H19.4283L19.584 4.19308L19.7361 4.49453H20.0244L19.7526 3.98933L20.0256 3.49453H19.7385L19.5944 3.81331ZM20.8 3.49453V3.72738H20.5551V4.49453H20.2961V3.72738H20.0512V3.49453H20.8ZM21.7935 3.79499C21.7575 3.61366 21.6154 3.49453 21.4132 3.49453C21.1636 3.49453 21 3.69241 21 3.99486C21 4.29996 21.1611 4.49453 21.4132 4.49453C21.6463 4.49453 21.8005 4.33834 21.8005 4.10274V3.98626H21.4309V4.09083H21.6868V4.11399C21.6868 4.27547 21.5768 4.38467 21.4138 4.38467C21.2306 4.38467 21.1162 4.2351 21.1162 3.99354C21.1162 3.75661 21.2325 3.60439 21.4132 3.60439C21.549 3.60439 21.6406 3.6719 21.6798 3.80161L21.7935 3.79499ZM22.5656 3.51713V3.62434H22.1145V3.93076H22.5422V4.03665H22.1145V4.36491H22.5656V4.47213H22.0008V3.51713H22.5656ZM23.3781 4.26035L22.8834 3.51713H22.7728V4.47213H22.8853V3.73156H22.8954L23.3901 4.47213H23.5006V3.51713H23.3882V4.26035H23.3781Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgNextGen2',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>